export const isEmail = (string) => {
  return !!string?.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/)
}
